import { IconButton, Tooltip } from '@wix/design-system';
import { useTranslation } from '@wix/fe-essentials/react';
import { ElementStatus } from '@wix/rules-panel-ui';
import { RevertSmall } from '@wix/wix-ui-icons-common';
import React from 'react';
import { useBiLogger } from '../../../../../hooks/use-bi-logger';
export const ColorSliderRevertIcon = _ref => {
  let {
    isGeneric,
    index,
    status,
    ctaName,
    colorState
  } = _ref;
  const {
    t
  } = useTranslation();
  const biLogger = useBiLogger();
  const {
    revert,
    hasChanged
  } = colorState;
  return /*#__PURE__*/React.createElement(Tooltip, {
    content: t('accessibility-wizard.rules-list.color-contrast.color-slider.revert'),
    size: "small"
  }, /*#__PURE__*/React.createElement(IconButton, {
    ariaLabel: t('accessibility-wizard.rules-list.color-contrast.color-slider.revert.aria-label'),
    disabled: !hasChanged,
    priority: "primary",
    size: isGeneric ? 'tiny' : 'small',
    skin: hasChanged ? 'light' : 'inverted',
    onClick: () => {
      biLogger.taskElementCtaClick({
        ctaName,
        index,
        status: status ? isGeneric ? ElementStatus.ManualPassed : ElementStatus.Passed : isGeneric ? ElementStatus.ManualFailed : ElementStatus.Failed
      });
      revert();
    }
  }, /*#__PURE__*/React.createElement(RevertSmall, null)));
};
//# sourceMappingURL=color-slider-revert-icon.js.map